module.exports = __webpack_public_path__ + "media/images/team_wecasa@2x-78c3eb6798bb407b80aa1009d9c8dcfa.jpg";